document.addEventListener('DOMContentLoaded', function () {
  const swiper_collection = new Swiper('.collection-list', {
    slidesPerView: 2,
    spaceBetween: 10,
    navigation: {                       
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
      1300: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
      1524: {
        slidesPerView: 3,
        spaceBetween: 10,
      },     
    }
  });
});